import processEnvSystem from 'unlikely-env/system'

export const isVercelProduction =
  processEnvSystem('VERCEL_ENV') === 'production'

export const isVercelPreview = processEnvSystem('VERCEL_ENV') === 'preview'

export const isVercelDevelopment =
  processEnvSystem('VERCEL_ENV') === 'development'
